import { React, useState, useEffect, useRef } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function DocScannerMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PDF Scanner & Document Scanner",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: {
      link: "/document_scanner",
      title: "Scan Documents To PDF Online Free",
    },
    data2: { link: "/document_scanner", title: "Document Scanner For Free" },
    data3: { link: "/document_scanner", title: "PDF Scanner Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Scan documents online instantly. Convert papers to PDF, capture receipts, notes, and forms quickly with our fast, secure document scanner tool."
      ></meta>
      <meta
        name="keywords"
        content="document scanner, scan documents online, PDF scanner, scan to PDF, online document scanner, receipt scanner, note scanner, mobile document scanner, scan forms online, digital document scanner, scan papers to PDF, secure document scanner, fast document scanning, online PDF scanner, document capture tool"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <></>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app-bundle/id${1863317370}`}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Document Scanner app provides a fast, secure, and reliable solution to scan documents offline and convert them into high-quality digital files without requiring an internet connection. Designed for privacy-focused users, this powerful document scanner free tool allows you to scan documents to PDF, capture images with your device camera, and convert paper documents into clear, professional PDFs instantly. With full offline functionality, all scanning and processing happens directly on your device, ensuring complete data security and confidentiality. Whether you need to digitize receipts, notes, contracts, assignments, or official paperwork, this PDF scanner free solution delivers accurate results with enhanced clarity and optimized file size. Using advanced image processing technology, the tool automatically detects edges, corrects perspective, and enhances text readability for high-quality scans. Users can scan documents, organize scanned files, and export them as PDFs or images with ease. Compatible with desktop and mobile devices, this offline document scanner is ideal for students, professionals, and businesses who need to scan documents to PDF anytime, anywhere—even without internet access. If you are searching for a reliable document scanner free, PDF scanner free, or a secure way to scan documents and scan documents to PDF offline, this website offers a user-friendly and dependable document scanning experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Scan",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Scanner"
            why_use={[
              {
                title: "Convert Paper Documents to Digital PDFs",
                description:
                  "A PDF scanner allows you to scan documents and convert paper files into digital PDFs for easy storage and sharing.",
              },
              {
                title: "Scan Documents to PDF Easily",
                description:
                  "With a document scanner free, users can quickly scan documents to PDF without needing bulky scanners or complex software.",
              },
              {
                title: "Work Offline for Better Privacy",
                description:
                  "Our offline PDF scanner free processes files directly on your device, keeping sensitive documents secure without internet access.",
              },
              {
                title: "Save Physical Storage Space",
                description:
                  "Scanning documents reduces the need for physical paperwork. Using a scan documents tool helps keep your workspace organized.",
              },
              {
                title: "Easy Sharing and Uploading",
                description:
                  "Digitized documents are easier to share. A scan documents to PDF feature enables fast email sending and online uploads.",
              },
              {
                title: "Improve Document Accessibility",
                description:
                  "Digital PDFs can be accessed anytime on multiple devices. A reliable document scanner free improves document availability.",
              },
              {
                title: "Enhance Text Clarity and Readability",
                description:
                  "Modern PDF scanner free tools enhance image quality and text clarity for professional-looking scanned documents.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students and professionals use scan documents tools for assignments, receipts, contracts, and official paperwork.",
              },
              {
                title: "Secure and Reliable Document Backup",
                description:
                  "Scanning documents creates digital backups. Our PDF scanner protects important files from loss or physical damage.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I scan documents online for free?",
                description:
                  "Visit ShivaPDF.com and open the Document Scanner tool. Use your device camera to capture a document or select an existing image, adjust the document boundaries if supported, and save the scanned result as a digital document."
              },
              {
                title: "Can I scan documents without uploading them?",
                description:
                  "ShivaPDF is designed to process supported document images locally in your browser. This allows you to scan or prepare documents without uploading their contents to a remote server when the complete workflow runs locally."
              },
              {
                title: "Is ShivaPDF's document scanner free?",
                description:
                  "ShivaPDF provides a browser-based document scanning tool for creating digital copies of paper documents. You can use the available features for free, subject to any usage limits displayed on the website."
              },
              {
                title: "Can I scan documents offline?",
                description:
                  "You may need an internet connection to open ShivaPDF.com initially. If the scanner and its required resources are available locally, you can capture and process documents without an active internet connection."
              },
              {
                title: "Are my scanned documents private and secure?",
                description:
                  "Local processing helps protect your privacy by keeping document images on your device rather than uploading them to a remote server. For sensitive documents, verify that the complete scanning and export workflow operates locally."
              },
              {
                title: "Can I use my phone as a document scanner?",
                description:
                  "Yes, you can use a supported browser on your iPhone or Android phone to capture paper documents with your device camera. The scanner can help you create digital copies of receipts, notes, forms, and other paperwork."
              },
              {
                title: "Do I need to install a document scanner app?",
                description:
                  "No, you can use ShivaPDF's browser-based document scanner without installing a separate application, provided your browser and device support the required camera features."
              },
              {
                title: "Can I convert scanned documents into PDF files?",
                description:
                  "Yes, if PDF export is supported, you can save captured document images as a PDF file. This makes it easier to store, print, email, and share digital copies of your paperwork."
              },
              {
                title: "Can I scan multiple pages into one PDF?",
                description:
                  "If multi-page scanning is supported, you can capture several pages and combine them into a single PDF document. This is useful for scanning contracts, reports, assignments, and multi-page forms."
              },
              {
                title: "Can I scan receipts and invoices?",
                description:
                  "Yes, you can use the document scanner to capture receipts, invoices, bills, and other paper records. Ensure the entire document is visible and the text is clear before saving the scanned copy."
              },
              {
                title: "Can I crop document edges after scanning?",
                description:
                  "If cropping is available, you can adjust the document boundaries to remove unwanted background areas and make the scanned result look cleaner. Position the crop around the document edges before exporting."
              },
              {
                title: "Can I improve the quality of scanned documents?",
                description:
                  "Good lighting, a steady camera, and a flat document surface help improve scan quality. If supported, use cropping, contrast adjustment, or grayscale filters to make the document easier to read."
              },
              {
                title: "Does the document scanner support OCR?",
                description:
                  "Optical character recognition (OCR) converts text in scanned images into searchable or selectable text. OCR availability depends on the features implemented in the ShivaPDF scanner; a scanned PDF alone does not necessarily contain searchable text."
              },
              {
                title: "Can I scan documents without creating an account?",
                description:
                  "You can use the document scanner without creating an account if registration is not required by the website. Check the tool page for any applicable usage restrictions."
              },
              {
                title: "Does ShivaPDF upload or store my scanned documents?",
                description:
                  "ShivaPDF's local-processing workflow is designed to handle supported document images directly in your browser without uploading their contents to a remote server. This helps keep your scanned documents on your device during processing."
              },
              {
                title: "Can I save scanned documents as images?",
                description:
                  "If image export is supported, you can save scanned documents in a compatible image format. Image files are useful for sharing individual pages, while PDF files are often more convenient for multi-page documents."
              },
              {
                title: "Can I scan documents using a laptop or desktop computer?",
                description:
                  "Yes, you can use a compatible desktop or laptop browser. If your computer has a supported camera, you may be able to capture documents directly; otherwise, select existing document images if the tool supports image uploads from your device."
              },
              {
                title: "Why should I use an online document scanner with local processing?",
                description:
                  "A browser-based document scanner with local processing lets you digitize paperwork without sending document contents to a remote server. It can simplify scanning while helping protect the privacy of receipts, forms, notes, and other personal documents."
              },
              {
                title: "How do I download my scanned document?",
                description:
                  "After capturing and adjusting your document, select the available export or download option to save the result to your device. Open the saved file to verify that all pages are readable and correctly oriented."
              },
              {
                title: "Can I scan documents without an internet connection?",
                description:
                  "Yes, if the scanner has already loaded and all required resources are available locally, you can capture and process documents without an active internet connection. Initial website access may require internet connectivity."
              }
            ]} />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default DocScannerMain;
